import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import Text from 'design-system/Text';
import { isoCodeToEmojiFlag } from 'utils/formatting';
const PhonePrefixesRow = ({ item, country }) => {
    const { prefix, iso2 } = item;
    if (prefix === '+')
        return null;
    return (<View style={styles.row}>
      <View style={styles.flex1}>
        <Text Text-16>
          {isoCodeToEmojiFlag(iso2)} {country}
        </Text>
      </View>
      <Text Numbers-16>{prefix}</Text>
    </View>);
};
const styles = StyleSheet.create({
    flex1: {
        flex: 1,
    },
    row: {
        padding: 15,
        flexDirection: 'row',
    },
});
export default memo(PhonePrefixesRow);
